<template>
  <div class="breadcrumb-wrapper">
    <!-- <el-breadcrumb>
      <template v-for="(item, key) of routerList" >
        <el-breadcrumb-item v-if="item&&item.path"
                            :key="key"
                            :to="{ path: item.path }">
          {{ item.name }}
        </el-breadcrumb-item>
        <el-breadcrumb-item v-else
                            :key="key">
          {{ item.name }}
        </el-breadcrumb-item>
      </template>
</el-breadcrumb> -->
    <div v-if="routerList.length > 0 " class="header-router-wrapper">
      <div class="header-page">{{ secondaryMenu ? secondaryMenu.name : routerList[0].name }}</div>
      <div v-if="routerList.length > 1" class="header-router">
        <div v-for="(item, index) in routerList" :key="item.menuUrl"
          :class="['header-router-item', item.menuUrl === curPage.path ? 'active' : '']"
          @click="handleRoute(item.menuUrl)">
          {{ item.name }}
          <template v-if="item.tip">
            <el-popover :ref="`popover${index}`" placement="bottom" trigger="click">
              <div class="breadcrumb-popover-tip">
                <div v-html="$t(item.tip)"></div>
              </div>
              <i slot="reference" class="iconfont icon-daohanglantishiicon margin-left-8"></i>
            </el-popover>
          </template>
          <p class="tab-line"></p>
        </div>
      </div>
    </div>
    <div v-else class="header-sub-page">
      <span class="icon-back" @click="onBackClick" v-if="!isTransView"><i class="el-icon-arrow-left"></i></span>
      <span class="header-sub-item">{{ getCurrentPageName() }}</span>
    </div>
    <!-- <img v-if="!pathList||pathList.length===0"
      src="../../assets/image/icon_back.png" alt="" class="back-image" @click="onBackClick"> -->
  </div>
</template>
<script>
import { ROUTE_GET, ROUTE_SET } from '@/store/modules/route.js';

export default {
  name: 'Breadcrumb',
  data() {
    return {
      pathList: null,
      curPage: {},
      routerList: [], // 三级菜单路由
      homeroutes: [],
      secondaryMenu: null, // 二级菜单
      isTransView: false,
    };
  },
  methods: {
    activeUrl(url) {
      const urlIndex = url.indexOf('?');
      const copyUrl = urlIndex > 0 ? url.substring(0, urlIndex) : url;
      return copyUrl;
    },
    getNavigation(navArray, url) {
      if (Object.prototype.toString.call(navArray) !== '[object Array]') {
        return;
      }
      navArray.forEach((item) => {
        try {
          if (item.menuUrl && url === item.menuUrl && +item.resourceType === 1) {
            this.pathList.push(item);
            this.getParentMenu(this.$store.getters.permission.menus, item.parentId);
          }
          this.getNavigation(item.childrenNode, url);
        } catch (e) {
          // eslint-disable-next-line no-throw-literal
          throw 'route is error!!';
        }
      });
    },
    getParentMenu(navArray, parentId) {
      if (Object.prototype.toString.call(navArray) !== '[object Array]') {
        return;
      }
      navArray.forEach((item) => {
        try {
          if (parentId === item.id) {
            this.pathList.unshift(item);
            this.getParentMenu(this.$store.getters.permission.menus, item.parentId);
          }
          this.getParentMenu(item.childrenNode, parentId);
        } catch (e) {
          // eslint-disable-next-line no-throw-literal
          throw 'routeId is error!!';
        }
      });
    },
    onRouteChangeListener() {
      this.curPage = this.$store.getters[ROUTE_GET];
      const { fullPath } = this.$store.getters[ROUTE_GET];
      this.pathList = [];
      this.routerList = [];
      this.secondaryMenu = null;
      this.getNavigation(this.$store.getters.permission.menus, this.activeUrl(fullPath));
      const len = this.pathList.length;

      let menusLens = 2;
      // 聚合商户会多一级
      if (this.$store.getters.app.userLogin.isAggregateMerchant) {
        menusLens = 3;
      }

      if (len > menusLens) { // 大于 2 说明当前为三级菜单
        let menus = this.pathList[1]; // 取出二级菜单中的所有三级菜单页面

        // 聚合商户会多一级
        if (this.$store.getters.app.userLogin.isAggregateMerchant) {
          menus = this.pathList[2];
        }
        this.routerList = menus.childrenNode.filter(item => +item.resourceType === 1);
        this.secondaryMenu = menus;
      } else if (len > 0) { // 否则将当前路由放入
        this.routerList = [this.pathList[len - 1]];

        // 特殊处理钱包页面标题  收单商户&&英文
        if (this.routerList[0].menuUrl === '/transfer/transfer' && this.$store.getters.app.currentLan === 'en') {
          this.routerList[0].name = 'Withdraw';
        }
      }
      // 提示语
      for (let i = 0; i < this.routerList.length; i++) {
        for (let j = 0; j < this.homeroutes.length; j++) {
          if (this.routerList[i].menuUrl === this.homeroutes[j].path) {
            const menu = this.homeroutes[j];
            if (menu.meta && menu.meta.tip) {
              this.routerList[i].tip = menu.meta.tip;
            }
            break;
          }
        }
      }
    },
    onBackClick() {
      if (this.curPage && this.curPage.meta && this.curPage.meta.backPath) {
        this.$router.push({ path: this.curPage.meta.backPath });
      } else if (window.history.length > 1) {
        window.history.back();
      } else {
        this.$router.push({ path: '/' });
      }
    },
    handleRoute(path) {
      this.$router.push({ path });
    },
    getCurrentPageName() {
      if (this.curPage && this.curPage.meta && this.curPage.meta.name) {
        return this.$t(this.curPage.meta.name);
      }
      return '';
    },
  },
  mounted() {
    this.$store.commit(ROUTE_SET, {
      value: this.$store.getters[ROUTE_GET],
      time: new Date().getTime(),
    });
    const routes = this.$router.options.routes;
    if (this.$route.path === '/transfer/transfer/view') {
      this.isTransView = true;
    }
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].path === '/') {
        this.homeroutes = routes[i].children;
        break;
      }
    }
  },
  watch: {
    '$store.state.route.routerTime': 'onRouteChangeListener',
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.breadcrumb-wrapper {
  display: flex;
  // height: 100%;
  width: 100%;
  align-items: center;

  .breadcrumb-box {
    //
  }

  .header-router-wrapper {
    width: 100%;

    .header-page {
      // height: 80px;
      padding-top: 14px;
      padding-bottom: 14px;
      font-weight: 900;
      font-size: 22px;
      color: $color-text-primary-new;
      line-height: 30px;
    }
  }

  .header-router {
    display: flex;
    align-items: center;
    margin-left: 36px;
    border-bottom: 1px solid #CBCFD9;

    .icon-daohanglantishiicon {
      color: $color-text-primary;
      opacity: 0.6;
      font-size: 16px;
    }

    .header-router-item {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      color: #80818C;
      line-height: 36px;
      margin-right: 50px;
      cursor: pointer;

      &.active {
        color: $color-text-default-button;

        .tab-line {
          display: block;
        }
      }

      .tab-line {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-bottom: 1px solid $color-text-default-button;
      }

      .icon-daohanglantishiicon {
        color: rgba($color: #264373, $alpha: 0.6);
      }
    }

    .icon-back {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 27px;
      height: 27px;
      background: #F1F5F7;
      border-radius: 4px;
      margin-right: 15px;
      cursor: pointer;

      .el-icon-arrow-left {
        font-weight: 800;
      }
    }
  }

  .header-sub-page {
    display: flex;
    align-items: center;
    font-size: 22px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: $color-text-primary;
    line-height: 30px;
    padding-top: 14px;
    padding-bottom: 14px;

    .icon-back {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 27px;
      height: 27px;
      background: #F1F5F7;
      border-radius: 4px;
      margin-right: 15px;
      cursor: pointer;

      .el-icon-arrow-left {
        font-weight: 800;
      }
    }
  }

  .el-breadcrumb .el-breadcrumb__inner {
    color: $color-text-primary !important;
  }

  .back-image {
    width: 20px;
    height: 20px;
    padding: 10px;
    cursor: pointer;
  }
}

@media screen and (max-width: 992px) {
  .breadcrumb-wrapper {
    display: none;
  }
}
</style>
